var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3479 5.83274C16.2189 5.29424 15.5386 5.11349 15.1471 5.50499C14.2059 6.44624 13.1574 7.49474 12.9511 7.70099C12.1741 8.47799 10.8834 8.43074 10.1694 7.55699C9.54836 6.79799 9.68111 5.66699 10.3749 4.97324L12.4944 2.85374C12.8859 2.46224 12.7059 1.78124 12.1674 1.65224C11.3829 1.46399 10.5346 1.44149 9.65561 1.63199C7.47236 2.10599 5.73236 3.89399 5.34161 6.09374C5.16611 7.08224 5.25086 8.03399 5.53586 8.89425L2.24186 12.1785C1.25336 13.167 1.25336 14.7697 2.24186 15.7582C3.23036 16.7467 4.83311 16.7467 5.82161 15.7582L9.12011 12.4695C9.97661 12.7507 10.9231 12.8325 11.9056 12.6577C14.1061 12.267 15.8941 10.5277 16.3674 8.34374C16.5586 7.46474 16.5354 6.61724 16.3479 5.83274Z",
    fill: "#BDCEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 15C4.74632 15 5.25 14.4963 5.25 13.875C5.25 13.2537 4.74632 12.75 4.125 12.75C3.50368 12.75 3 13.2537 3 13.875C3 14.4963 3.50368 15 4.125 15Z",
    fill: "#4671F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.f9606eb49c580ff12081fda1cd1e7124.svg";
export { ForwardRef as ReactComponent };